import { useNavigate } from "react-router-dom";
import { Mic, ChevronRight, Users } from "lucide-react";

export const potential = (s) => (typeof s !== "number" ? { label: "À analyser", cls: "bg-slate-500/15 text-slate-600 dark:text-slate-400", emoji: "⏳" }
  : s >= 70 ? { label: "Chaud", cls: "bg-rose-500/15 text-rose-600 dark:text-rose-400", emoji: "🔥" }
  : s >= 45 ? { label: "Moyen", cls: "bg-amber-500/15 text-amber-700 dark:text-amber-400", emoji: "🟡" }
  : { label: "Froid", cls: "bg-slate-400/15 text-slate-600 dark:text-slate-400", emoji: "⚪" });

export default function PriorityLeads({ leads }) {
  const navigate = useNavigate();
  const sorted = [...leads].sort((a, b) => (b.aiClassification?.conversionScore ?? -1) - (a.aiClassification?.conversionScore ?? -1)).slice(0, 8);
  return (
    <div className="klt-glow-card rounded-3xl p-5" data-testid="priority-leads">
      <div className="flex items-center justify-between">
        <p className="font-heading font-bold">Leads prioritaires</p>
        <button onClick={() => navigate("/dashboard")} data-testid="priority-leads-all" className="text-xs font-semibold text-muted-foreground hover:text-foreground inline-flex items-center gap-0.5">Tous <ChevronRight className="w-3.5 h-3.5" /></button>
      </div>
      {sorted.length === 0 ? <div className="text-center py-8 text-sm text-muted-foreground"><Users className="w-8 h-8 mx-auto mb-2 opacity-40" />Aucun lead — appuyez sur le micro ⚡</div> : (
        <ul className="mt-3 space-y-2">
          {sorted.map((l) => {
            const c = l.contactInfo || {};
            const s = l.aiClassification?.conversionScore;
            const p = potential(s);
            const name = [c.firstName, c.lastName].filter(Boolean).join(" ") || c.company || "Sans nom";
            return (
              <li key={l.id} className="flex items-center gap-3 rounded-2xl bg-secondary/40 p-3" data-testid={`priority-lead-${l.id}`}>
                <button onClick={() => navigate(`/lead/${l.id}`)} className="min-w-0 flex-1 text-left">
                  <p className="text-sm font-semibold truncate">{name}</p>
                  <p className="text-xs text-muted-foreground truncate">{c.company || c.role || "Prospect"}</p>
                </button>
                <span className={`text-[11px] font-bold rounded-full px-2 py-1 whitespace-nowrap ${p.cls}`} data-testid={`priority-badge-${l.id}`}>{typeof s === "number" ? `${s}% ` : ""}{p.emoji} {p.label}</span>
                <button onClick={() => navigate(`/lead/${l.id}`, { state: { focusDebrief: true } })} data-testid={`priority-debrief-${l.id}`} aria-label="Relancer / Débriefer" className="w-9 h-9 rounded-full klt-fab-neon flex items-center justify-center shrink-0" style={{ boxShadow: "none" }}><Mic className="w-4 h-4" /></button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
